import React, { Component } from 'react';
import Helmet from 'react-helmet';
import './support.scss';

class SupportPage extends Component {
    render() {
        return (
            <div className='support-container'>
                <Helmet title={`Datasert - Support`} />

                <div className='content'>
                    <h2>
                        Using Realfire?
                    </h2>
                    <p>Please use the "Help -> Contact Support" menu to send us a support request. Please include the errors logs so we can understand the issue and resolve it faster.</p>

                    <h2>
                        Email Us
                    </h2>
                    <p>Please email us at <a href="mailto:support@datasert.com">support@datasert.com</a> and we will do our best to have it resolved.</p>
                    <p>If we determine the issue is not isolated to you alone, we will create an issue in Github and track it.</p>

                    <h2>
                        Have a feature requetst?
                    </h2>
                    <p>Please create an issue in appropriate product repo at <a href="https://github.com/datasert">https://github.com/datasert</a></p>
                    <p>If the feature request is appropriate, we will do our best to have it implemented as soon as we can</p>
                </div>
            </div>
        );
    }
}

export default SupportPage;


// WEBPACK FOOTER //
// ./src/pages/resources/support.jsx